import { createContext } from 'react';

import { ValidationStepContextType } from './ValidationStepContext.types';

export const ValidationStepContext = createContext<ValidationStepContextType | undefined>(undefined);
